import React, { FC, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";

import { withProcedureWraper } from "../..";
import { Routes } from "../../../../AppRoutes";
import { Box } from "../../../../components/box";
import { Icon } from "../../../../components/icon";
import { getDDMMYYYFormat, isDateInRange } from "../../../../helper/dateTimeHelper";
import CreateRequestButton from "../../components/CreateRequestButton";
import { AiOutlineFilter } from "react-icons/ai";
import { ExportFileExcel } from "../../info-technology-process/components";
import { compareRequestStatus, getRequestStatusHasAssigneeOptions } from "../../utils";
import moment, { Moment } from "moment";
import { useBusinessTicketsColumn } from "./hooks/use-business-tickets-column";
import { useBusinessTicketsRequests } from "./hooks";
import { Table, UserManual } from "../../../../components";

export const procedureCollaborateTicket: FC = withProcedureWraper(() => {
  const history = useHistory();
  const { columns } = useBusinessTicketsColumn();
  const {
    mappedBusinessTicketsMyRequests,
    mappedBusinessTicketsRequests = [],
    isLoading,
    guideLink,
  } = useBusinessTicketsRequests();

  const [filters, setFilters] = useState<any>({
    createdDateTime: null,
    eRequestStatus: null,
  });

  const filteredDataSource = useMemo(() => {
    let dataSource = [...mappedBusinessTicketsRequests];
    if (filters.eRequestStatus) {
      dataSource = dataSource.filter((e: any) => compareRequestStatus(e.eRequestStatus, filters?.eRequestStatus!));
    }
    if (filters.createdDateTime) {
      const [startDate, endDate]: [Moment, Moment] = filters.createdDateTime;
      dataSource = dataSource.filter((e: any) => {
        const createDate = moment(e.createdDateTime);
        return isDateInRange(createDate, startDate.startOf("day"), endDate.endOf("day"));
      });
    }

    return dataSource;
  }, [filters, mappedBusinessTicketsRequests]);

  const requestStatusOptions = getRequestStatusHasAssigneeOptions("Đã cấp mới");

  const flattedData = mappedBusinessTicketsRequests.map((record: any) => ({
    createdDateTime: getDDMMYYYFormat(record.createdDateTime),
    eRequestStatus: record.eRequestStatus,
    eRequestPersonName: record.createdByName,
    ePhoneNumber: record.ePhoneNumber,
    eDepartment: record.eDepartment,
    eUnit: record.eUnit,
    eDescription: record.eDescription,
    eRequestStatusText: requestStatusOptions.find((e) => e.value === record.eRequestStatus)?.label,
  }));

  return (
    <div className="ITCodeGrantedPage">
      <div className="pd15">
        <UserManual title="CẤP/HOÀN VÉ CÔNG TÁC" icon={<Icon.CarCV />} guideLink={guideLink} />
        <Box
          title="Yêu cầu của tôi"
          titleRight={
            <CreateRequestButton
              onClick={() => history.push(Routes.createProcedureCollaborateTicket.path.replace(":id", "0"))}
            />
          }
        >
          <Table
            loading={isLoading}
            rowKey="id"
            columns={columns}
            dataSource={mappedBusinessTicketsMyRequests}
            onRow={(record) => ({
              onClick: () => history.push(Routes.procedureCollaborateTicketDetailPage.path.replace(":id", record.id)),
              style: { cursor: "pointer" },
            })}
          />
        </Box>

        <Box
          title="Các yêu cầu cần duyệt"
          titleRight={
            <ExportFileExcel
              exportContent={{
                fileName: "Danh sach yeu cau can duyet cap ve cong tac",
                content: [
                  { header: "Người yêu cầu", dataIndex: "eRequestPersonName" },
                  { header: "SĐT Người yêu cầu", dataIndex: "ePhoneNumber" },
                  { header: "Cơ quan/Đơn vị", dataIndex: "eDepartment" },
                  { header: "Đơn vị", dataIndex: "eUnit" },
                  { header: "Mô tả", dataIndex: "eDescription" },
                  { header: "Trạng thái", dataIndex: "eRequestStatusText" },
                ],
              }}
              data={flattedData}
              initialValues={filters}
              requestStatusOptions={requestStatusOptions}
              onChange={(_, allValues: any) => setFilters(allValues)}
            >
              <div>
                <CreateRequestButton label="Bộ lọc" prefixIcon={<AiOutlineFilter />} />
              </div>
            </ExportFileExcel>
          }
        >
          <Table
            loading={isLoading}
            rowKey="id"
            columns={columns}
            dataSource={filteredDataSource}
            onRow={(record) => ({
              onClick: () => history.push(Routes.procedureCollaborateTicketDetailPage.path.replace(":id", record.id)),
              style: { cursor: "pointer" },
            })}
          />
        </Box>
      </div>
    </div>
  );
});
